<template>
    <AssemblyDashboard></AssemblyDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const AssemblyDashboard = defineAsyncComponent(() =>
    import("../../components/Assembly/Dashboard.vue")
);

export default {
    name: "Assembly_Dashboard", //The name you are in should not equal the name of the component you are importing.
    components: { AssemblyDashboard, AuthLayout },
};
</script>
